import React from 'react';
import Portfolio from './Portfolio';

// Import styles
import './index.css';

const App = () => {
  return (
    <div className="font-sans">
      <Portfolio />
    </div>
  );
};

export default App;
